import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  results: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_COMMUNITY_RESULTS:
      return Object.assign({}, state, {
        isLoading: true,
        error: false,
        results: [],
      });
    case types.RECEIVE_COMMUNITY_RESULTS:
      return Object.assign({}, state, {
        isLoading: false,
        error: false,
        results: action.payload.results,
      });
    case types.RECEIVE_COMMUNITY_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        error: true,
        results: [],
      });
    default:
      return state;
  }
}
